import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Grid, Form, Message } from 'semantic-ui-react'
import { useForm, Controller } from "react-hook-form"
import axios from 'axios'
import parse from 'html-react-parser';
import getLocalStorage from '../../utils/getLocalStorage'
import { useUIDispatch } from '../../context/store'

function Login() {
    const history = useHistory();
    const dispatch = useUIDispatch();
    const { control, handleSubmit, errors } = useForm();
    // const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loginErrors, setLoginErrors] = useState([]);
    const onSubmit = data => {
        setLoading(true);
        axios.post(`${window.theme_vars.wp_rest}jwt-auth/v1/token`, data)
        .then(({data}) => {
            if ( undefined === data.token ) {
                return;
            }

            // console.log(data);
            // setIsLoggedIn(true);
            localStorage.setItem('wp_user_auth', JSON.stringify(data));
            dispatch({
                'type': 'UPDATE_QUERY_USER',
                payload: data.user_id
            });
            // localStorage.setItem('user_token', data.token);
            // localStorage.setItem('user_email', data.user_email);
            // localStorage.setItem('user_nicename', data.user_nicename);
            // localStorage.setItem('user_branch', data.user_branch);
            // localStorage.setItem('user_id', data.user_id);
            setLoading(false);
            history.push('/overview');
        })
        .catch(function (error) {
            setLoginErrors([error.response.data.message]);
            setLoading(false);
            // setIsLoggedIn(false);
        })
    };

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            const formErrors = Object.entries(errors).map((x,i) => x[1].message);
            setLoginErrors(formErrors);
        }
    }, [errors])

    if(getLocalStorage('token')){
        console.log('redirect');
    }

    return (
        <Container>
            <Grid style={{paddingTop: 90}}>
                <Grid.Row centered columns={3}>
                    <Grid.Column>
                        {! _.isEmpty(loginErrors) && <Message error>
                            {Object.keys(loginErrors).length > 1 ?
                                <Message.List items={loginErrors} /> :
                                <Message.Content>{parse(loginErrors[0])}</Message.Content>
                            }
                        </Message>}
                        <Form loading={loading} onSubmit={handleSubmit(onSubmit)}>
                            <Form.Field>
                                <Controller
                                    control={control}
                                    name="username"
                                    defaultValue=""
                                    rules={{
                                        required: {value: true, message:'Please enter email address'},
                                        pattern: {
                                            value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                            message: "Email address must be valid."
                                        }
                                    }}
                                    render={({onChange, value}) => <Form.Input label="Email"
                                        value={value}
                                        onChange={onChange}
                                    />}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Controller
                                    control={control}
                                    name="password"
                                    defaultValue=""
                                    rules={{
                                        required:{value:true, message:'Password is required.'}
                                    }}
                                    render={({onChange, value}) => <Form.Input label="Password"
                                        type="password"
                                        value={value}
                                        onChange={onChange}
                                    />}
                                />
                            </Form.Field>

                            <button type="submit" className="ui button primary">Submit</button>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
}

export default Login
